export default __webpack_public_path__ + "static/media/icon_users_active.27bd0f22.svg";